import React from "react";
import {NarrowContainer} from "@acc-monorepo/gatsby-stories/styles/shared";
import {PayNowButton} from "@acc-monorepo/gatsby-stories/integrations/eway/PayNowButton";
import {StyledSection} from "./pageStyles";
import styled from "styled-components";

const StyledPurchaseSection = styled(StyledSection)`
  color: white;
  background-color: var(--darkblue);
  
  h2 {
    color: inherit;
    margin-top: 1rem;
  }
  
  .order-container {
    display: flex;
    flex-direction: column;
    width: 100%;
   
    > div {
      width: 100%;
    }
  }
  
  .eway-button {
    display: block;
    position: relative;
    width: auto;
    margin: 1rem auto 2rem auto;
    padding: 1.2rem 1.5rem;
    border: solid 2px var(--lightblue);
    border-radius: 5px;
    text-transform: uppercase;
    font-size: .8rem;
    letter-spacing: .08rem;
    text-decoration: none;
    color: #fff;
    background-color: var(--lightblue);
    transition: all .5s ease;
    font-weight: 500;
    text-align: center;
    white-space: normal;
    vertical-align: middle;
    
    span {
      border: none;
      font-family: montserrat, arial, sans-serif !important;
      box-shadow: none;
    }
  }
  
  @media(min-width: 768px) {
    .order-container {
      flex-direction: row;

      > div {
        width: 50%;
      }
      > div:first-child {
        margin-right: 3rem;
      }
    }

    .eway-button {
      margin-left: 0;
      margin-right: 0;
    }
  }
`

export const PurchaseSection = ({volume, journalName, ...props}) => {
  return (
    <StyledPurchaseSection>
      <NarrowContainer>
        <h2>Purchase your hard copy of the {volume.year} edition</h2>
        <p style={{marginBottom: "1.25rem"}}>Limited numbers of the journal are printed in hard copy for purchase. Select from either domestic or international postage options below.</p>
        <div className="order-container">
          <div>
            <p>To purchase a copy of Vol. {volume.number}, {volume.year} within Australia, click the button below. Price includes postage. After we have received payment you will be contacted for a delivery address.</p>
            <PayNowButton
              publicApiKey="epk-1AC47BBD-DED0-43DF-89C6-651DB05DAE07"
              label="ORDER NOW"
              amount="1700"
              buttonColor="#0069B4"
              invoiceDescription={`${journalName} Journal`}
              invoiceRef={volume.invoiceRef + "AUS"}
              currency="AUD"
            />
          </div>
          <div>
            <p>To purchase a copy of Vol. {volume.number}, {volume.year} outside Australia, click the button below. Price includes postage. After we have received payment you will be contacted for a delivery address.</p>
            <PayNowButton
              publicApiKey="epk-1AC47BBD-DED0-43DF-89C6-651DB05DAE07"
              label="ORDER NOW"
              amount="3500"
              buttonColor="#0069B4"
              invoiceDescription={`${journalName} Journal`}
              invoiceRef={volume.invoiceRef + "INT"}
              currency="AUD"
            />
          </div>
        </div>
      </NarrowContainer>
    </StyledPurchaseSection>
  )
}

export default PurchaseSection
